<template>
    <div class="yq-es-query-input">
        <div class="yq-es-query-input-wrapper">
            <el-input v-bind="$attrs" :value="value" @input="$emit('input', $event)"></el-input>
            <el-link icon="el-icon-question" :underline="false" type="primary" @click="dialogVisible=true"></el-link>
        </div>
        <el-dialog title="帮助" :visible.sync="dialogVisible" width="60%" append-to-body>
            <div>
                <p>1. 字段匹配 使用"字段名:查询词"来指定字段名进行查询</p>
                <p>例如：</p>
                <p>TITLE:中国&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询"TITLE"中包含"中国"的记录</p>
                <p>2. 条件关系 AND, OR, NOT</p>
                <p>AND 表示与关系 OR 表示或关系 NOT表示非关系</p>
                <p>例如：</p>
                <p>TITLE:(中国 AND 北京)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询"TITLE"中包含"中国"和"北京"的记录</p>
                <p>TITLE:中国 OR CONTENT:北京&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询"TITLE"中包含"中国"或者"CONTENT"包含"北京"的记录</p>
                <p>TITLE:中国 NOT CONTENT:北京&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询"TITLE"中包含"中国"排除"CONTENT"包含"北京"的记录</p>
                <p>3. 通配符查询</p>
                <p>"?"表示单个字符，"*"表示0个或多个字符</p>
                <p>*:*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询所有记录</p>
                <p>4. 范围查询</p>
                <p>范围查询允许指定某个字段最大值和最小值，查询在二者之间的所有记录。范围查询可以包含或者不包含最大值和最小值，包含用[表示，不包含用{表示。</p>
                <p>date:[2020.01.01 TO 2021.10.01] &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询( 2020.01.01 ≤ date ≤ 2021.10.01)</p>
                <p>date:{2020.01.01 TO 2021.10.01} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询(2020.01.01 &lt; date $lt; 2021.10.01)</p>
                <p>date:[2020.01.01 TO *} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询(date ≥ 2020.01.01)</p>
                <p>time:{* TO "2021.10.01 00:00:00"] &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查询(time ≤ 2021.10.01 00:00:00)</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "EsQueryInput",
        props: {
            value: String
        },
        data() {
            return {
                dialogVisible: false
            }
        }
    }
</script>

<style scoped>

</style>
